import React from 'react';
import { setListJobSearchText } from '../../../redux/actions';
import { useDispatch, useSelector } from 'react-redux';
import Control from '../../form/Control';
import text from '../../../text';
import Icon from '../../icon/Icon';
var SearchControl = function() {
    var dispatch = useDispatch();
    var searchText = useSelector(function(state) {
        return {
            searchText: state.jobsReducer.listJobFilter.searchText
        };
    }).searchText;
    var handleChange = function(e) {
        dispatch(setListJobSearchText(e.target.value));
    };
    var handleClear = function() {
        dispatch(setListJobSearchText(''));
    };
    return /*#__PURE__*/ React.createElement("div", {
        id: "SearchControl"
    }, /*#__PURE__*/ React.createElement(Control, {
        as: "input",
        type: "text",
        name: "search",
        value: searchText,
        onChange: handleChange,
        placeholder: text('searchHere'),
        autoComplete: "off"
    }), /*#__PURE__*/ React.createElement(Icon, {
        className: "clear-search",
        onClick: handleClear,
        icon: "cross"
    }));
};
export default SearchControl;
